import { IQSelectOptions } from '@/quasar-types'
import { date } from 'quasar'

export function getSchoolYearOptions(today: Date): IQSelectOptions[] {
  // Both dates represent the first half of a schoolyear
  const dateFrom = date.adjustDate(today, { month: 7, date: 31 })
  const dateTo = date.adjustDate(date.addToDate(today, { year: 1 }), { month: 1, date: 1 })

  const isStartOfSchoolYear = date.isBetweenDates(today, dateFrom, dateTo)

  let year = isStartOfSchoolYear ? date.addToDate(today, { year: 1 }) : today

  const options: IQSelectOptions[] = []

  for (let i = 0; i < 5; i++) {
    const previousYear = subtractYearFromDate(year)

    options[i] = {
      label: date.formatDate(previousYear, 'YYYY') + ' - ' + date.formatDate(year, 'YYYY'),
      value: previousYear + '_' + year,
    }

    year = previousYear
  }

  return options
}

function subtractYearFromDate(dateToSubtract: object): string {
  return date.subtractFromDate(dateToSubtract, { year: 1 })
}
